// ======================================================================
// File Name       : DistributionReportList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Table, Button, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead from '../../TableHead';
import * as distributionAction from '../../../actions/report/DistributionAction';
import {
  DEFAULT_DATE_FROM,
  DEFAULT_DATE_TO,
  DEFAULT_DATE_TO_TEXT,
  DEFAULT_DATE_FROM_TEXT,
  DEFAULT_DATE_FORMAT,
} from '../../../constants/index';
import { parseDateForDetail } from '../../../utils/index';
import PaginationCustom from '../../Pagination';
import CustomLink from '../../button/CustomLink';

class DistributionReportList extends React.Component {
  constructor(props) {
    super(props);
    this.handleShowDialogAssignment = this.handleShowDialogAssignment.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
  }
  /**
   * handle sorting data
   * @param {*} row
   */
  handleSortState(row) {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportList } = distributionReport;
    const { searchInfo } = distributionReportList;
    searchInfo.reportHistorySortType = row.sortBy;
    searchInfo.ascendingDescendingSort = row.sortState;
    dispatch(distributionAction.updateDistributionReportSearchInfo(searchInfo));
    dispatch(distributionAction.searchDistributionReport());
  }

  handleShowDialogAssignment(itemReportIdAuto) {
    const { dispatch } = this.props;
    dispatch(distributionAction.openReportDialog(itemReportIdAuto));
  }

  /**
     * Pagination
     * @param {*} startPosition
     */
  getStartEndData(startPosition) {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportList } = distributionReport;
    const { searchInfo } = distributionReportList;
    searchInfo.startPosition = startPosition;
    dispatch(distributionAction.updateDistributionReportSearchInfo(searchInfo));
    dispatch(distributionAction.searchDistributionReport());
  }

  render() {
    const { distributionReport, recordNum, hoverIndex } = this.props;
    const { distributionReportList } = distributionReport;
    const { searchInfo, distributionReportListResult } = distributionReportList;
    const { startPosition } = searchInfo;

    const thead = [
      { title: 'レポート名', sortBy: null },
      { title: '未分配レポート件数', sortBy: null, width:'10%' },
      { title: '提出期限', sortBy: null, width:'15%' },
      { title: '結果返却予定日', sortBy: null, width: '15%' },
      { title: '操作', sortBy: null, width: 100 },
    ];
    const distributionReportListTable =
      distributionReportListResult &&
      distributionReportListResult.length > 0 &&
      distributionReportListResult.map((report, index) => {
        const reportDeadline = parseDateForDetail(report.reportDeadline, DEFAULT_DATE_FORMAT, DEFAULT_DATE_TO_TEXT);
        const reportReturnPlanDate = parseDateForDetail(report.reportReturnPlanDate, DEFAULT_DATE_FORMAT, DEFAULT_DATE_FROM_TEXT);
        return (
          <tr key={index} onMouseEnter={() => this.props.handleMouseEnter(index)} onMouseLeave={() => this.props.handleMouseLeave()}>
            <td>{report.reportName}</td>
            <td>{report.reportNum}</td>
            <td>{reportDeadline}</td>
            <td>{reportReturnPlanDate}</td>
            <td className="text-center">
              <CustomLink
                className="margin-right-7 link-detail"
                onClick={this.handleShowDialogAssignment.bind(this, report.itemReportIdAuto)}
                text="分配する"
              />
            </td>
          </tr>
        );
      });
    return (
      <div id="distributionReportListTable">
        <Table striped hover>
          <thead>
            <TableHead data={thead} handleSortState={this.handleSortState} />
          </thead>
          <tbody>{distributionReportListTable}</tbody>
        </Table>
        <Col sm={12} className="margin-bottom-10 d-flex justify-content-center">
          <PaginationCustom
            recordNum={recordNum}
            handlePageSelect={this.getStartEndData}
            startPosition={startPosition}
          />
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { form, distributionReport } = state;
  return {
    distributionReport,
  };
};

export default connect(mapStateToProps)(DistributionReportList);
